import eruda from 'eruda'
let vConsole = {}
if (process.env.VUE_APP_VCONSOLE) {
  eruda.init()
} else {
  vConsole = {}
}

export default vConsole
